import React from "react";
import TrendUp from "../../assets/svg/icons/common/TrendUp";
import TrendDown from "../../assets/svg/icons/common/TrendDown";
import ArrowRight from "../../assets/svg/icons/common/ArrowRight";
import ArrowIcon from "../../assets/svg/icons/common/arrow";
import styles from "./TrendPercent.module.scss";

function TrendPercent({ percent }) {
  const renderIcon = () => {
    if (percent > 0) {
      return <TrendUp />;
    } else if (percent == 0) {
      return <ArrowRight />;
    } else {
      return <TrendDown />;
    }
  };

  const renderText = () => {
    if (percent > 0) {
      return <span className={styles.trend_up}>+{percent}%</span>;
    } else if (percent == 0) {
      return <span className={styles.trend_neutral}>+{percent}%</span>;
    } else {
      return <span className={styles.trend_down}>{percent}%</span>;
    }
  };

  return (
    <div className={styles.trend_percent_container}>
      {renderIcon()}
      {renderText()}
    </div>
  );
}

export default TrendPercent;
